/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetUnit} from '../api'

export const useMutationBatchGetUnit = createReactQueryMutationHook('batchGetUnit', batchGetUnit)
